const permissions = [
  {
    _id: "",
    label: "Select",
    disabled: true,
  },
  {
    _id: "0",
    label: "Admin and Physician Permission",
  },
  {
    _id: "1",
    label: "Physician Permission",
  },
  {
    _id: "2",
    label: "Nurse Permission",
  },
  {
    _id: "3",
    label: "Secretary Permission",
  },
];

export default permissions;
